import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { LogoMark } from "@/components/Logo";
import { scrollToSection } from "@/lib/scroll";
import { EASE } from "@/lib/motion";

const LINKS = [
    { label: "Work", hash: "#work" },
    { label: "About", hash: "#about" },
    { label: "Services", hash: "#services" },
    { label: "Contact", hash: "#contact" },
];

export default function Nav() {
    const [open, setOpen] = useState(false);
    const go = (hash) => {
        setOpen(false);
        setTimeout(() => scrollToSection(hash), open ? 250 : 0);
    };

    return (
        <>
            <header className="fixed top-0 inset-x-0 z-40 border-b border-black/5 bg-paper/85 backdrop-blur-xl">
                <div className="flex items-center justify-between px-5 md:px-10 h-16">
                    <button data-testid="nav-home" onClick={() => go("#top")} className="flex items-center gap-3 cursor-pointer">
                        <LogoMark size={26} />
                        <span className="font-display font-extrabold tracking-tight text-sm uppercase">Hitanshu Shah</span>
                    </button>
                    <nav className="hidden md:flex items-center gap-8">
                        {LINKS.map((l) => (
                            <button
                                key={l.hash}
                                data-testid={`nav-link-${l.hash.slice(1)}`}
                                onClick={() => go(l.hash)}
                                className="text-xs font-semibold uppercase tracking-[0.18em] text-inkdim hover:text-ink transition-colors duration-300 cursor-pointer"
                            >
                                {l.label}
                            </button>
                        ))}
                    </nav>
                    <div className="hidden md:block">
                        <button
                            data-testid="nav-cta"
                            onClick={() => go("#contact")}
                            className="bg-ink text-paper text-xs font-bold uppercase tracking-[0.18em] px-6 py-3 hover:bg-inkdim transition-colors duration-300 cursor-pointer"
                        >
                            Start a project
                        </button>
                    </div>
                    <button data-testid="nav-menu-toggle" className="md:hidden p-2" onClick={() => setOpen(true)} aria-label="Open menu">
                        <Menu size={24} />
                    </button>
                </div>
            </header>

            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className="fixed inset-0 z-[70] bg-paper flex flex-col px-6 py-6 md:hidden"
                        data-testid="nav-mobile-menu"
                    >
                        <div className="flex justify-between items-center">
                            <LogoMark size={26} />
                            <button data-testid="nav-menu-close" onClick={() => setOpen(false)} aria-label="Close menu" className="p-2">
                                <X size={26} />
                            </button>
                        </div>
                        <div className="flex-1 flex flex-col justify-center gap-1">
                            {LINKS.map((l, i) => (
                                <motion.button
                                    key={l.hash}
                                    initial={{ opacity: 0, y: 24 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: 0.08 + i * 0.07, duration: 0.5, ease: EASE }}
                                    onClick={() => go(l.hash)}
                                    className="text-left font-display font-extrabold uppercase text-5xl tracking-tight py-3 border-b border-line cursor-pointer"
                                >
                                    {l.label}
                                </motion.button>
                            ))}
                        </div>
                        <button
                            onClick={() => go("#contact")}
                            className="bg-ink text-paper py-4 text-xs font-bold uppercase tracking-[0.2em] cursor-pointer"
                        >
                            Start a project
                        </button>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
}
